// extracted by mini-css-extract-plugin
module.exports = {"selectedUser":"selectOwner_selectedUser__3-XcX","selectedUserName":"selectOwner_selectedUserName__3vex2","avatar":"selectOwner_avatar__1Veks"};